import React, { useEffect, useState } from "react";
import style from "./AllProject.module.css";
import { fetchBen } from "../../API";
import ReactRotatingText from "react-rotating-text";
import { useSpring, animated } from "react-spring";
import HambugerTop from "../HambugerTop/HambugerTop";
import Loader from "../Loader/Loader";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import profileImg from "../../Images/Update 2.1/profile.svg";


const AllProject = ({ toggle, allProjectServer, setAllProjectServer, setProjPageTimer }) => {
  const [benPlatform, setBenPlatform] = useState([]);
  const [stopper, setStopper] = useState(null);
  const [images, setImages] = useState({
    logo:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096991/logo_nh5kui.svg",
    Fb_Img:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096988/facebook_yuritk.svg",
    Ig_Img:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096990/instagram_pevhyd.svg",
    be_Img:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096988/behance_ukv0je.svg",
    lk_Img:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096990/linkedin-3_p4yh62.svg",
    tw_Img:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096993/twitter_prkdsa.svg",
    mouseImg:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096992/mouse_qwtl1u.svg",
    mcBookImg:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605021641/Macbook_o9y5ch.svg",
  });

  const fetchAPI = async () => {
    setTimeout(async () => {
      setBenPlatform(await fetchBen());
    }, 2000);
  };
  useEffect(() => {
    fetchAPI();
  }, [stopper]);

  useEffect(() => {
    Aos.init({
      duration: 1000,
    });
  });

  benPlatform ? setAllProjectServer(true) : setAllProjectServer(false);
  const { productMe, sampleProj } = benPlatform;

  if(sampleProj){
      var sampleImg1 = sampleProj[0].img1;
      var sampleImg2 = sampleProj[1].img1;
      var sampleImg3 = sampleProj[2].img1;
      var sampleImg4 = sampleProj[3].img1;
  }

  if(productMe && sampleImg1 && sampleImg2 && sampleImg3 && sampleImg4 && sampleProj) setProjPageTimer(true);

  return sampleProj && productMe ? (
    <section className={style.container}>
      <animated.div>
        <div>
          <div className={style.linkSmallScreen}>
            <img src={images.logo} alt="logo" className={style.logo} />
            <div className={style.hambuger2} onClick={() => toggle(true)}>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={style.overallCnt}>
            <div className={style.works}>
              <img className={style.logo} src={images.logo} alt="logo" />
              <p className={style.para}>Bennovela 2020</p>
            </div>
            <div className={style.carousel}>
              <div className={style.carousel2}>
                <div className={style.innerDiv}>
                  <h1>
                    <ReactRotatingText
                      items={benPlatform.projectPageTitles}
                      pause={2000}
                      typingInterval={100}
                      cursor={false}
                    />
                  </h1>
                </div>
              </div>
            </div>
            <div className={style.contact}>
              <div className={style.innerDiv2}>
                <HambugerTop toggle={toggle} />
                <p className={style.para2}>Contact Me</p>
                <div className={style.links}>
                  <a href="https://www.instagram.com/rampiongram/">
                    <img
                      src={images.Ig_Img}
                      className={style.linkImg}
                      alt="Instagram logo"
                    />
                  </a>
                  <a href="https://twitter.com/rampiondml">
                    <img
                      src={images.tw_Img}
                      className={style.linkImg}
                      alt="twitter logo"
                    />
                  </a>
                  <a href="https://m.facebook.com/benjaminosewminge?ref=bookmarks">
                    <img
                      src={images.Fb_Img}
                      className={style.linkImg}
                      alt="Facebook logo"
                    />
                  </a>
                  <a href="https://behance.net/rampiondml">
                    <img
                      src={images.be_Img}
                      className={style.linkImg}
                      alt="Behance logo"
                    />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/benjamin-osemwengie-8a0b171b7/"
                    target="_blank"
                  >
                    <img
                      src={images.lk_Img}
                      className={style.linkImg}
                      alt="Linkedin logo"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </animated.div>
      <div className={style.productMe}>
        <div className={style.innerProductMe}>
          <div>
            <h1>{productMe.heading}</h1>
            <p>{productMe.details}</p>
          </div>
        </div>
      </div>
      <div className={style.projContainer} >
      {sampleProj.map((proj) => (
        <div className={style.proj}>
          <div data-aos={"fade-up"} className={style.ImageContainer}>
            <img className={style.img2} src={proj.img2} alt="project Image2" />
           
          </div>
          <div data-aos={"fade-up"} className={style.projectInfo}>
            <h1>{proj.projName}</h1>
            <p>{proj.projDesc}</p>
            <a className={style.viewLink} href={proj.linkTo}>
              View Project
            </a>
          </div>
        </div>
      ))}
      </div>
    </section>
  ) : (
    <Loader allProjectServer={allProjectServer} />
  );
};

export default AllProject;
